<template>
    <div class="main-message">
        <mensajeria-checkout 
        v-if="service_selected" 
        :message="service_selected"
        @closeCheckout="service_selected = $event"
        >
        </mensajeria-checkout>
        <div class="message-content" v-show="!service_selected">
            <button type="button" class="boton-install-android" @click.prevent="install" v-if="showInstallBanner" > + INSTALAR APP <br><label class="label-install-android"><i class="fas fa-bullhorn i-install-android"></i>Promociones exclusivas (No te ocupa espacio).</label></button>
            <div id="pwa-ios-notify"  class="ios-notify abajo-izquierda" style="display: none !important;">    <h3 class="equis"><span aria-hidden="true" id="close" @click="Close()">&times;</span></h3> 
                <label class="info" id="info" >
                Para instalar esta Aplicación: <br>
                1. Presione el icono Compartir <img style="margin-top: -5px;" src="/share1.png"><br>
                2. De click en Agregar a inicio <i class="far fa-plus-square"></i> y luego agregar.<br>  
                </label>
            </div>
            <div class="message-portada">
                <img v-bind:src="url_images + portada">
            </div>
            <div class="message-logo-content">
                <div class="message-name">
                    <h4>{{ data.name }}</h4>
                </div>
                <div class="companie-logo">
                    <img v-bind:src="url_images + logo">
                </div>
            </div>
            <div class="message-detail">
                <h4 class="message-hour"><i class="far fa-clock"></i> {{ data.horario }}</h4>
                <h4 class="message-map"><i class="fas fa-map-marker-alt"></i>{{data.address}}</h4>
            </div>

            <div class="search-service">
                <input type="text" placeholder="Buscar..." autocomplete="off" class="input-message">
                <div class="search-icon" v-bind:style="{backgroundColor : color_botones }"><i class="fas fa-search"></i></div>
            </div>

            <div class="content-services" v-bind:style="{backgroundColor : color_botones }">
                <h4>¿En que te podemos ayudar hoy?</h4>
                <div class="all-services">
                    <div class="single-service" v-for="item in data.categorias[0].products" @click="openCheckout(item)">
                        <div class="image-container" v-bind:style="{backgroundColor : color_botones }">
                            <img v-bind:src="url_images + item.galery_images[0]" alt="">
                        </div>
                        <h5>{{ item.name }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css">

    @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

    .boton-install-android{
        font-size: 16px;
        background-color: #1D8BFA;
        color: white;
        width: 100%;
        border: none;
        padding-top: 7px;
        font-weight: 500;
    }
    .label-install-android{
        font-size: 14px;
        font-weight: 500;
    }
    .i-install-android{
        margin-right: 0.35rem;
        color:white;
    }

    .ios-notify{      
        background-color: #1D8BFA;
        color: white;     
        width: 90%;
        margin-left: 18px;
        border-radius: 15px;
        position: fixed !important;           
        padding-left: 40px !important;          
        padding-right: 40px !important;
        bottom: 10px;  
        height: 160px;   
        padding-bottom: 40px !important;
        text-align: left;
    }

    .abajo-izquierda:before {
      content: "";
      position: absolute;
      bottom: -15px;
      text-align: center;
      left: 0;
      right: 0;
      margin: auto;
      width: 0;
      height: 0;
      border-width: 25px 25px 0;
      border-style: solid;
      border-color: #1D8BFA transparent transparent;
         
    }
    .equis{
      font-size: 24px;
      font-weight: 600;
      text-align: right !important;
      line-height: 10px;
      padding-top: 15px;
    }
    .info{          
      font-size: 16px;
      font-weight: 600;   
       
    }

    *:focus{
        outline: none;
    }

    .message-portada img{
        width: 100%;
        height: auto;
        border-bottom-left-radius: 35px;
    }

    .image-container{
        border-radius: 50%;
        padding: 25px 15px;
        width: 110px;
        margin: 0 auto;
    }

    @supports(object-fit: cover){
        .message-portada img{
          height: 100%;
          object-fit: cover;
          object-position: center center;
        }
    }

    .message-logo-content{
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-right: 20px;
    }

    .companie-logo{
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0px 0px 12px 0px rgba(204,204,204,1);
        margin-top: -70px;
        padding: 15px;
        background: #fff;
    }

    .companie-logo img{
        width: 100%;
        height: auto;
    }

    .message-name{
        padding-top: 15px;
        padding-left: 20px;
    }
    .message-name h4{
        font-family: 'Poppins', sans-serif;
        font-size: 21px;
        font-weight: 500;
        margin-bottom: 0 !important;
    }

    .message-detail{
        width: 100%;
        padding: 8px 20px;
        text-align: left;
    }

    .message-hour{
        font-family: 'Poppins', sans-serif;
        font-size: 13px;
    }

    .message-hour i{
        font-size: 16px;
        margin-right: 5px;
    }

    .message-map{
        font-family: 'Poppins', sans-serif;
        font-size: 13px;
    }

    .message-map i{
        font-size: 16px;
        margin-right: 7px;
    }   

    .search-service{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 20px;
        display: none;
    }

    .input-message{
        width: 83%;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
        border: 1px solid #cccccc;
        padding: 7px 13px;
    }

    .search-icon{
        width: 12%;
        border-radius: 10px;
        padding: 6px 18px;
        border: none;
    }

    .search-icon i{
        color: #fff;
        font-weight: 600 !important;
    }

    i.fas.fa-search::before{
        margin-left:-7px;
    }

    .content-services{
        width: 100%;
        padding: 25px 20px;
        border-top-right-radius: 35px;
        text-align: left;
        margin-top: 15px;
    }

    .content-services h4{
        font-family: 'Poppins', sans-serif;
        font-size: 17px;
        font-weight: 500;
        color: #fff;
    }

    .all-services{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0px;
        flex-wrap: wrap;
    }

    .single-service img{
        width: 70%;
    }

    .single-service{
        width: 46%;
        border-radius: 10px;
        background: #fff;
        text-align: center;
        padding: 20px 0px;
        margin-right: 10px;
        margin-bottom: 15px;
    }

    .single-service:hover{
        cursor: pointer;
    }

    .single-service h5{
        font-family: 'Poppins', sans-serif;
        font-size: 18px;
        font-weight: 500;
        padding-top: 15px;
    }

</style>

<script>
    import MensajeriaCheckout from './MensajeriaCheckout.vue';
    let installEvent;
    export default{
        props: ['data'],
        components: {
            MensajeriaCheckout
        },
        data(){
            return {
                showInstallBanner: false,
                url_images: "https://back.vinapp.co/",
                portada: this.data.portada,
                logo: this.data.logo,
                color_botones: this.data.color,
                service_selected: ''
            }
        },
        watch:{
            
        },
        methods:{
            Close(){    
                document.getElementById('pwa-ios-notify').style.display = 'none'; 
            }, 
            install() {
                this.showInstallBanner = false;
                installEvent.prompt();
                installEvent.userChoice.then(() => {
                    installEvent = null;
                });
            },
            openCheckout(service){
                this.service_selected = service;
            }
        },
        mounted(){
            window.addEventListener('beforeinstallprompt', e => {
              e.preventDefault();
              installEvent = e;
              this.showInstallBanner = true;
            });
             // Detects if device is on iOS 
            const isIos = () => {
                const userAgent = window.navigator.userAgent.toLowerCase();      
                return /iphone|ipad|ipod/.test( userAgent );
            } 
            const isFacebookApp = ()  => {
              const ua = navigator.userAgent || navigator.vendor || window.opera;
              return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
            }
            // Detects if device is in standalone mode
            const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
            // Checks if should display install popup notification:
            if (isIos() && !isInStandaloneMode()){
                if(!navigator.userAgent.includes("Instagram") && !isFacebookApp()){
                    document.getElementById('pwa-ios-notify').style.display = 'block'; 
                    document.getElementById('pwa-ios-notify').style.zIndex = "3" ;
                }
            } 
        }
    }
</script>